// extracted by mini-css-extract-plugin
module.exports = {"head":"style-module--head--LJ-7P","block":"style-module--block--1JhcS","header":"style-module--header--21LKC"};